

















































import { Component , Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
const cssPrefix = 'CSCWCMDialog';
@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
})
export default class CSCWCMDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showWirelessDialog: boolean;
  created() {
    console.warn('this.dataCenter');
  }
  closeDialog() {
    this.$emit('close-dialog');
  }
  launchWifi() {
    console.warn('wifi launch');
    this.$emit('launchWifi');
  }
}
